import { render, staticRenderFns } from "./DeleteConfirmationModal.vue?vue&type=template&id=2d46ffa1&scoped=true"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=2d46ffa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46ffa1",
  null
  
)

export default component.exports